// extracted by mini-css-extract-plugin
export var divider = "_og-0";
export var systemMessage = "_og-1";
export var systemMessageWrapper = "_og-2";